import { SvgIcon, styled } from "@mui/material";

export const Objective = styled("span")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(0.5),
}));

export const Icon = styled(SvgIcon)(({ theme }) => ({
  fontSize: theme.iconSize.sm,
  // this icon renders 4px offline; I don't know why, but this resets it where it should be
  marginTop: "-9px",
  position: "relative",
  top: "5px",
}));

export const Descriptor = styled("span")({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const Baseline = styled("span")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(0.5),
}));

export const Operator = styled("span")(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));
